import { useQuery } from '@tanstack/react-query';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';
import type { ContactAnalyticsResponse } from '@signalvote/shared';

/**
 * Fetch contact analytics, optionally scoped to a single volunteer and/or vendor
 */
export function useContactAnalytics(volunteerId?: string, vendorId?: string) {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.analytics.contactAnalytics(volunteerId, vendorId),
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (volunteerId) searchParams.set('volunteerId', volunteerId);
      if (vendorId) searchParams.set('vendorId', vendorId);
      const qs = searchParams.toString();
      return apiJson<ContactAnalyticsResponse>(`/api/analytics/contact-analytics${qs ? `?${qs}` : ''}`, {
        error: 'Failed to fetch contact analytics',
      });
    },
    enabled: authService.isAuthenticated() && !!selectedCampaign,
    staleTime: 5 * 60 * 1000,
  });
}
